/**
 * COZINESS V2: HEADER ANIMATIONS
 * Handles Glassmorphism scroll effects and Dynamic Mega Menu interactions.
 */

document.addEventListener('DOMContentLoaded', () => {
    initGlassHeader();
    initDynamicMegaMenu();
    initMegaMenuHoverFix();
    initSearchBehavior();
    initMegaMenuInstantClose();
});

/**
 * Instant-close für das Mega-Menu.
 * Prestige hat in createHideAnimationControls() eine 400ms opacity-
 * fade-out Animation. Override mit einer Controls-like Struktur die
 * sofort resolvet — die close()-Logik in MenuDisclosure entfernt das
 * open-Attribut erst NACH .finished.then(). Mit instant-Promise
 * geschieht das im naechsten Microtask = visuell sofort.
 */
function initMegaMenuInstantClose() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('mega-menu-disclosure').then(function () {
        var MegaMenuDisclosure = customElements.get('mega-menu-disclosure');
        if (!MegaMenuDisclosure || !MegaMenuDisclosure.prototype) return;
        MegaMenuDisclosure.prototype.createHideAnimationControls = function () {
            return { finished: Promise.resolve({}) };
        };
    });
}

/**
 * Handles the "Glassmorphism" effect on scroll.
 */
function initGlassHeader() {
    const header = document.querySelector('.cz-header-innovator');
    if (!header) return;

    // Threshold for when the header becomes "glass"
    const scrollThreshold = 50;

    const handleScroll = () => {
        if (window.scrollY > scrollThreshold) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    };

    /* rAF-throttle: vorher feuerte handleScroll bei JEDEM scroll event
       (modern Browser ~60 events/s, langsame Geraete unbounded) → forced
       Style-Recalc auf jedem. Jetzt max 1× pro Frame. */
    let scrollTicking = false;
    window.addEventListener('scroll', function () {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
            handleScroll();
            scrollTicking = false;
        });
    }, { passive: true });
    // Initial check
    handleScroll();
}


/**
 * Handles the "Dynamic Image" swapping in the Mega Menu.
 * Looks for links with `data-vibe-image` and updates the side image.
 */
function initDynamicMegaMenu() {
    const menuItems = document.querySelectorAll('.cz-mm-link');

    menuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            const imageUrl = item.getAttribute('data-vibe-image');
            const targetId = item.closest('.mega-menu').getAttribute('id');
            const targetImage = document.querySelector(`#${targetId} .cz-mm-image img`);

            if (imageUrl && targetImage) {
                // Fade out, swap, fade in
                targetImage.style.opacity = 0;
                setTimeout(() => {
                    targetImage.src = imageUrl;
                    targetImage.style.opacity = 1;
                }, 200);
            }
        });
    });
}

/**
 * Handles Search Preview Closing Behavior (Click Outside only)
 *
 * Previously also closed on every scroll event past y=100, which caused
 * results to disappear on each keystroke (layout shifts from typing fire
 * the scroll listener). Removed that. Results now stay open until the
 * user clicks outside or empties the input.
 */
function initSearchBehavior() {
    const searchForm = document.querySelector('.cz-search-form');
    const searchResults = document.querySelector('.cz-predictive-override');
    if (!searchForm || !searchResults) return;

    const searchInput = searchForm.querySelector('input[type="search"]');

    /* ═══ PORTAL: move the dropdown to <body> so it escapes any ancestor
       stacking / containing-block quirks (sticky header-group, header's
       backdrop-filter when .is-scrolled, etc.). Re-position it with
       JS based on the search form's current viewport rect. This makes
       the backdrop-filter blur the actual page content consistently on
       every page/template, not just homepage. */
    const origParent = searchResults.parentNode;
    let portaled = false;
    let movedToBody = false;

    function positionPortal() {
        if (!portaled) return;
        // Top anker an den Header-Bottom (nicht den Search-Form-Bottom),
        // damit die Box wirklich UNTER dem Header sitzt — das Search-Form
        // hat eigenes Padding/Margin innerhalb des Headers, was vorher zu
        // einer leichten Ueberlappung mit der Header-Unterkante gefuehrt
        // hat. Header-Rect ist die echte sichtbare Unterkante.
        const header = document.querySelector('.cz-header-innovator');
        const formRect = searchForm.getBoundingClientRect();
        const topPx = header
            ? header.getBoundingClientRect().bottom
            : formRect.bottom + 8;
        searchResults.style.top = topPx + 'px';
        /* Mittig unter dem Suchfeld statt rechtsbuendig daran. Die Box ist
           480px breit, das Feld rund 200px: an der rechten Kante verankert
           waechst sie nur nach links und wirkt gegen das Feld versetzt.
           Zentriert — und an den Viewport-Rand geklemmt, damit sie nie
           hinauslaeuft. offsetWidth ist 0, solange die Box noch display:none
           hat; dann greift die CSS-Breite als Annahme. */
        const boxW = searchResults.offsetWidth || 480;
        const edge = 16;
        let leftPx = formRect.left + formRect.width / 2 - boxW / 2;
        leftPx = Math.max(edge, Math.min(leftPx, window.innerWidth - edge - boxW));
        searchResults.style.left = leftPx + 'px';
        searchResults.style.right = 'auto';
    }
    /* WICHTIG (Tab-Switch-Bug): <predictive-search> wird NUR EINMAL nach document.body
       verschoben (movedToBody-Guard). Jeder weitere appendChild — auch zum selben Parent —
       feuert disconnect/reconnect am enthaltenen <x-tabs>-Web-Component und zerstoert dessen
       Click-Delegate (nur im constructor gebunden) -> Reiter nach Re-Focus nicht mehr klickbar.
       Darum: einmal moven, danach nur noch Klasse/Listener togglen + ein-/ausblenden. */
    function portal() {
        if (!movedToBody) {
            document.body.appendChild(searchResults);
            movedToBody = true;
        }
        searchResults.classList.add('cz-predictive-override--portaled');
        document.documentElement.classList.add('cz-search-open');
        portaled = true;
        positionPortal();
        window.addEventListener('resize', positionPortal, { passive: true });
        window.addEventListener('scroll', positionPortal, { passive: true });
    }
    function unportal() {
        if (!portaled) return;
        /* KEIN Move zurueck zu origParent — der Reparent wuerde disconnect/reconnect am
           <x-tabs> ausloesen und den Tab-Click-Delegate dauerhaft toeten. Element bleibt
           in document.body, wird nur ausgeblendet (display:none setzt der Caller). */
        searchResults.classList.remove('cz-predictive-override--portaled');
        document.documentElement.classList.remove('cz-search-open');
        searchResults.style.top = '';
        searchResults.style.right = '';
        searchResults.style.left = '';
        portaled = false;
        window.removeEventListener('resize', positionPortal);
        window.removeEventListener('scroll', positionPortal);
    }

    /* ═══ SCROLL-GUARD (narrow window) ═══
       The unwanted viewport nudge happens right after each keystroke
       (predictive-search fetches / renders / lazy-loads thumbnails).
       Only pin scrollY for ~250ms after each input event. Outside that
       window, scrolling is fully free. User-initiated wheel/touch
       cancels the lock immediately. */
    let lockedScrollY = null;
    let lockExpiresAt = 0;

    function armLock(durationMs = 250) {
        lockedScrollY = window.scrollY;
        lockExpiresAt = performance.now() + durationMs;
    }
    function releaseLock() {
        lockedScrollY = null;
        lockExpiresAt = 0;
    }

    if (searchInput) {
        searchInput.addEventListener('focus', function () {
            portal();
            if (searchInput.value.length > 0 && searchResults.innerHTML.trim().length > 0) {
                searchResults.style.display = 'block';
            }
        });
        searchInput.addEventListener('input', function () {
            portal();
            armLock(250);
            if (searchInput.value.length > 0) {
                searchResults.style.display = 'block';
            }
        });

        /* User-initiated scroll gestures cancel the lock immediately */
        ['wheel', 'touchmove', 'keydown'].forEach(function (ev) {
            window.addEventListener(ev, function (e) {
                // Arrow keys in the input shouldn't cancel (they don't scroll anyway)
                if (ev === 'keydown' && e.target === searchInput) return;
                releaseLock();
            }, { passive: true });
        });

        /* Snap back only within the active window, only when triggered
           by something non-user (scroll event with no preceding wheel/touch) */
        window.addEventListener('scroll', function () {
            if (lockedScrollY === null) return;
            if (performance.now() > lockExpiresAt) { releaseLock(); return; }
            if (Math.abs(window.scrollY - lockedScrollY) > 0.5) {
                window.scrollTo({ top: lockedScrollY, behavior: 'instant' });
            }
        }, { passive: true });
    }

    // Close on click outside the search form AND results panel
    document.addEventListener('click', function (event) {
        if (!searchForm.contains(event.target) && !searchResults.contains(event.target)) {
            searchResults.style.display = 'none';
            releaseLock();
            unportal();
        }
    });

    // Close on Escape
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && searchResults.style.display !== 'none') {
            searchResults.style.display = 'none';
            searchInput && searchInput.blur();
            releaseLock();
            unportal();
        }
    });
}

/**
 * Ensures mega menus open on hover even when Prestige's pointer:fine
 * detection returns false (e.g. on touchscreen laptops with a mouse).
 * Uses the disclosure element's own toggle() API so animations work.
 */
function initMegaMenuHoverFix() {
    var disclosures = document.querySelectorAll(
        'mega-menu-disclosure[trigger="hover"], dropdown-menu-disclosure[trigger="hover"]'
    );

    /**
     * User-Bug: Beim schnellen Wechsel von Hauptkategorie A zu B war A
     * noch wegen des 250ms Close-Delay sichtbar, waehrend B schon offen
     * war → kurzzeitige Ueberlappung. Fix: bei jedem mouseenter ALLE
     * anderen Disclosures sofort schliessen (Timer canceln + toggle(false)),
     * bevor das aktuelle geoeffnet wird. Eigene Close-Timer werden
     * pro disclosure am Element gehalten (._czHoverTimer) damit sich
     * mehrere Disclosures nicht gegenseitig in die Quere kommen.
     */
    function closeOthers(except) {
        disclosures.forEach(function (d) {
            if (d === except) return;
            if (d._czHoverTimer) {
                clearTimeout(d._czHoverTimer);
                d._czHoverTimer = null;
            }
            // Hard-close: <details>.open=false direkt setzen — bypassed
            // jegliche Close-Animation/Transition die toggle(false) sonst
            // triggern wuerde. Das ist warum der Overlap auftritt: toggle()
            // animiert, und waehrend des Fade-Outs ist das alte Menue noch
            // sichtbar. Direkter open=false toggle ist instant.
            var det = d.querySelector('details');
            if (det && det.open) {
                det.open = false;
            }
            // Toggle-API danach NOCH callen damit das custom-element interne
            // State (aria-expanded etc.) sauber sync'd ist.
            if (typeof d.toggle === 'function') {
                d.toggle(false);
            }
        });
    }

    /* Ruhigere Maus (24.10.):
       (1) Schliessen erst nach CLOSE_MS (vorher 250): zwischen Menuepunkt und
           Panel liegt ein Streifen Header; wer dort kurz innehielt, verlor das
           Menue und klickte auf die Seite darunter. Gilt fuer den eigenen
           Timer unten und, per Getter, fuer Prestiges mouseout-Schliessen.
       (2) Ist schon ein anderes Menue offen, oeffnet ein Punkt erst nach
           INTENT_MS Verweilen: bei zweizeiliger Navigation kreuzt der Weg
           vom offenen Menue nach unten Punkte der zweiten Zeile, die sonst
           sofort uebernahmen. Das erste Oeffnen bleibt sofort. Prestiges
           eigenes mouseover-Umschalten wird in genau diesem Fall in der
           Capture-Phase abgefangen; geoeffnet wird dann hier (mit hartem
           closeOthers, ohne Ueberlappung). */
    var CLOSE_MS = 400;
    var INTENT_MS = 150;

    customElements.whenDefined('mega-menu-disclosure').then(function () {
        var C = customElements.get('mega-menu-disclosure');
        Object.defineProperty(C.prototype, 'mouseOverDelayTolerance', {
            configurable: true,
            get: function () { return CLOSE_MS; }
        });
    });

    function otherOpen(disclosure) {
        return Array.prototype.some.call(disclosures, function (d) {
            if (d === disclosure || d.contains(disclosure) || disclosure.contains(d)) return false;
            var det = d.querySelector('details');
            return !!(det && det.open);
        });
    }

    document.addEventListener('mouseover', function (e) {
        var disclosure = e.target.closest && e.target.closest('mega-menu-disclosure[trigger="hover"], dropdown-menu-disclosure[trigger="hover"]');
        if (!disclosure || !disclosure.closest('.header__primary-nav')) return;
        var det = disclosure.querySelector('details');
        if (det && !det.open && otherOpen(disclosure)) e.stopPropagation();
    }, true);

    disclosures.forEach(function (disclosure) {
        var details = disclosure.querySelector('details');
        if (!details) return;

        /* Verzoegerter Hover-CLOSE + Cancel-bei-Reenter.
           WARUM wir den Close selbst machen muessen: Prestige's nativer
           mouseout-Close ist (wie das Open) an pointer:fine gekoppelt. Auf
           Touch-Laptops / coarse-Pointer — genau den Geraeten, fuer die diese
           Funktion das Menu ueberhaupt erst per Hover OEFFNET — feuert Prestige's
           Close NICHT → das Mega-Menu blieb offen, auch beim Weg-Hovern.
           Der alte Cursor-Transit-Bug (Gap Summary→Panel schloss zu frueh) wird
           durch die 250ms-Verzoegerung + Cancel-bei-Reenter vermieden: in der
           Luecke startet nur ein Timer; erreicht der Cursor das Panel, wird er
           gecancelt. Listener am AEUSSEREN disclosure-Element (umschliesst Summary
           + Panel im DOM), damit interne Bewegungen kein mouseleave ausloesen. */
        function czScheduleClose() {
            if (disclosure._czHoverTimer) clearTimeout(disclosure._czHoverTimer);
            disclosure._czHoverTimer = setTimeout(function () {
                disclosure._czHoverTimer = null;
                var det = disclosure.querySelector('details');
                if (det && det.open) { det.open = false; }
                if (typeof disclosure.toggle === 'function') { disclosure.toggle(false); }
            }, CLOSE_MS);
        }
        function czCancelClose() {
            if (disclosure._czHoverTimer) { clearTimeout(disclosure._czHoverTimer); disclosure._czHoverTimer = null; }
        }

        function openThis() {
            // Alle anderen Mega-Menus sofort hart schliessen — keine Ueberlappung
            // beim Schnell-Switch A->B.
            closeOthers(disclosure);
            if (typeof disclosure.toggle === 'function') {
                disclosure.toggle(true);
            }
        }

        details.addEventListener('mouseenter', function () {
            czCancelClose();
            clearTimeout(disclosure._czIntent);
            if (!details.open && otherOpen(disclosure)) {
                disclosure._czIntent = setTimeout(function () {
                    disclosure._czIntent = null;
                    if (details.matches(':hover')) openThis();
                }, INTENT_MS);
                return;
            }
            openThis();
        });
        details.addEventListener('mouseleave', function () {
            clearTimeout(disclosure._czIntent);
            disclosure._czIntent = null;
        });

        // Weg-Hovern schliesst (verzoegert); Reenter (auch durch den Gap) cancelt.
        disclosure.addEventListener('mouseenter', czCancelClose);
        disclosure.addEventListener('mouseleave', czScheduleClose);
    });
}

// initSearchBehavior() is invoked inside DOMContentLoaded above so
// the search form/dropdown elements exist when we try to bind to them.
